module.exports = __webpack_public_path__ + "static/media/group_30@2x.aceb331b.jpg";